/**
 * Seconds since a wait began, ticking once a second while it is in flight.
 *
 * Shared by the two GBP waits so they cannot drift apart. Resets to zero every
 * time the wait restarts — a re-check or a client switch must start from zero
 * rather than carry the previous wait's clock.
 */
import { useEffect, useRef, useState } from "react";

export function useElapsedSeconds(waiting: boolean): number {
	const [elapsed, setElapsed] = useState(0);
	const startedAt = useRef<number | null>(null);

	useEffect(() => {
		if (!waiting) {
			startedAt.current = null;
			setElapsed(0);
			return;
		}
		startedAt.current = Date.now();
		setElapsed(0);
		const id = window.setInterval(() => {
			if (startedAt.current === null) return;
			setElapsed((Date.now() - startedAt.current) / 1000);
		}, 1000);
		return () => window.clearInterval(id);
	}, [waiting]);

	return elapsed;
}
